import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { isDevMode, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
  ProtectedResourceScopes
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { NetworkHierarchyServiceResourceService, NodeServiceResourceService, NWT_BASE_PATH } from '@psnb/nwt-api';
import { BASE_PATH, PSNB_BASE_PATH } from '@psnb/psnb-api';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import {
  MaterialDeleteDialogComponent
} from 'desktop/power-supply/power-supply-edit/powersupply-certification-workitems/material-delete-dialog.component';
import {
  WorkItemDeleteDialogComponent
} from 'desktop/power-supply/power-supply-edit/powersupply-certification-workitems/work-item-delete-dialog.component';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import { ValidationErrorDialog } from 'desktop/power-supply/Upload/power-supply-bulk-upload/validation-error-dialog';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PowerSupplyMessageDialog } from './common/message-dialog/power-supply-message-dialog';
import { UploadDialog } from './common/message-dialog/upload-dialog';
import { MaterialModule } from './material/material.module';
import { PowerSupplyAlertsComponent } from './power-supply/power-supply-alerts/power-supply-alerts.component';
import {
  PowerSupplyEditApuVisitComponent
} from './power-supply/power-supply-apu/power-supply-edit-apu-visit/power-supply-edit-apu-visit.component';
import {
  PowerSupplyEditApuComponent
} from './power-supply/power-supply-apu/power-supply-edit-apu/power-supply-edit-apu.component';
import {
  PowerSupplyEditSupplyComponent
} from './power-supply/power-supply-apu/power-supply-edit-supply/power-supply-edit-supply.component';
import {
  PowerSupplyEditSupplysfpComponent
} from './power-supply/power-supply-apu/power-supply-edit-supplysfp/power-supply-edit-supplysfp';
import { PowerSupplyCreateComponent } from './power-supply/power-supply-create/power-supply-create.component';
import { PowerSupplyCreatedDialog } from './power-supply/power-supply-create/power-supply-created-dialog.component';
import { PowerSupplyNameDialog } from './power-supply/power-supply-create/power-supply-name-dialog.component';
import {
  PowerSupplyNameNetConnectDialog
} from './power-supply/power-supply-create/power-supply-name-netconnect-dialog.component';
import {
  PowerSupplyTooltipComponent
} from './power-supply/power-supply-create/Validations/powersupply.type.tooltip.ts/power-supply-tooltip/power-supply-tooltip.component';
import { PowerSupplyDetailsComponent } from './power-supply/power-supply-details/power-supply-details.component';
import { BlockCopyPasteDirective } from './power-supply/power-supply-edit/block-copy-paste.directive';
import { PowerSupplyEditComponent } from './power-supply/power-supply-edit/power-supply-edit.component';
import {
  PowerSupplyNameEditNetConnectDialog
} from './power-supply/power-supply-edit/power-supply-name-editnetconnect-dialog.component';
import { PowerSupplyUpdatedDialog } from './power-supply/power-supply-edit/power-supply-updated-dialog.component';
import { PowerSupplyListComponent } from './power-supply/power-supply-list/power-supply-list.component';
import { PowerSupplyNavBarComponent } from './power-supply/power-supply-nav-bar/power-supply-nav-bar.component';
import { PowerSupplyNotebookComponent } from './power-supply/power-supply-notebook/power-supply-notebook.component';
import { SharedService } from './power-supply/power-supply-telemetry/datashared.service';
import {
  EditTestDurationRendererComponent
} from './power-supply/power-supply-telemetry/power-supply-selftestdata/edit-test-duration-renderer.component';
import {
  PowerSupplySelftestdataComponent
} from './power-supply/power-supply-telemetry/power-supply-selftestdata/power-supply-selftestdata.component';
import { SearchPipe } from './power-supply/power-supply-telemetry/power-supply-selftestdata/search.pipe';
import {
  SelftestconfirmDialogComponent
} from './power-supply/power-supply-telemetry/power-supply-selftestdata/selftestconfirm-dialog/selftestconfirm-dialog.component';
import {
  PowerSupplyTelemetryPsScoredialogComponent
} from './power-supply/power-supply-telemetry/power-supply-telementrydata-psScore-dialog/power-supply-telementrydata-psScore-dialog.component';
import {
  PowerSupplyTelemetryThresholddialogComponent
} from './power-supply/power-supply-telemetry/power-supply-telemetry-thresholddialog/power-supply-telemetry-thresholddialog.component';
import { PowerSupplyTelemetryComponent } from './power-supply/power-supply-telemetry/power-supply-telemetry.component';
import { PowerSupplyTestComponent } from './power-supply/power-supply-test/power-supply-test.component';
import { PowerSupplyComponent } from './power-supply/power-supply.component';
import { PowerSupply401Component } from './power-supply/power-supply401/power-supply401.component';
import { PowerSupplypage401Component } from './power-supply/power-supplypage401/power-supplypage401.component';
import {
  PowersupplyCertWorkitemComponent
} from './power-supply/powersupply-cert-workitem/powersupply-cert-workitem.component';
import { PsnbCerthistoryComponent } from './power-supply/psnb-certhistory/psnb-certhistory.component';
//Generator Components
import { CreateAssetDialogComponent } from './power-supply/create-asset-dialog/create-asset-dialog.component';
import { PowerSupplyGeneratorAssetDetailsComponent } from './power-supply/power-supply-generator-asset-details/power-supply-generator-asset-details.component';
import { PowerSupplyGeneratorCreateComponent } from './power-supply/power-supply-generator-create/power-supply-generator-create.component';
import { PowerSupplyGeneratorEditComponent } from './power-supply/power-supply-generator-edit/power-supply-generator-edit.component';
import { SearchDataDeployGeneratorDialogComponent } from './power-supply/power-supply-generator-searchdata/deploy-generator-dialog/deploy-generator-dialog.component';
import { PowerSupplySelectionDialogComponent } from './power-supply/power-supply-generator-searchdata/deploy-generator-dialog/power-supply-selection-dialog.component';
import { SearchDataQrScannerDialogComponent } from './power-supply/power-supply-generator-searchdata/deploy-generator-dialog/qr-scanner-dialog.component';
import { PowerSupplyGeneratorSearchDataComponent } from './power-supply/power-supply-generator-searchdata/power-supply-generator-searchdata.component';
import { PowerSupplyGeneratorSearchlistComponent } from './power-supply/power-supply-generator-searchlist/power-supply-generator-searchlist.component';
import { DeployGeneratorDialogComponent } from './power-supply/power-supply-telemetry/deploy-generator-dialog/deploy-generator-dialog.component';
import { QrScannerDialogComponent } from './power-supply/power-supply-telemetry/deploy-generator-dialog/qr-scanner-dialog.component';
import { RefuelRecoveryGeneratorDialogComponent } from './power-supply/power-supply-telemetry/refuel-recovery-generator-dialog/refuel-recovery-generator-dialog.component';

export function loggerCallback(logLevel: LogLevel, message: string): void {
  console.log(`MSAL ${logLevel}: ${message}`); // eslint-disable-line no-console
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      authority: environment.authority,
      clientId: environment.clientId,
      redirectUri: environment.redirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: isDevMode() ? LogLevel.Info : LogLevel.Warning,
        piiLoggingEnabled: false
      }
    }
  });
}


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap: Map<string, Array<string | ProtectedResourceScopes>> =
    new Map<string, Array<string | ProtectedResourceScopes>>();
  if (isDevMode()) {
    protectedResourceMap.set('http://localhost:4200/api/*', environment.scope);
    protectedResourceMap.set('http://localhost:4200/corejson/*', environment.scope);
  }
  protectedResourceMap.set(`${environment.psnbBaseUri}/api/*`, environment.scope);
  protectedResourceMap.set(`${environment.psnbBaseUri}/corejson/*`, environment.scope);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    authRequest: {
      scopes: environment.scope
    },
    interactionType: InteractionType.Redirect
  };
}

@NgModule({
  bootstrap: [AppComponent, MsalRedirectComponent],
  declarations: [
    AppComponent,
    BlockCopyPasteDirective,
    CreateAssetDialogComponent,
    DeployGeneratorDialogComponent,
    EditTestDurationRendererComponent,
    MaterialDeleteDialogComponent,
    PowersupplyCertWorkitemComponent,
    PowerSupply401Component,
    PowerSupplyAlertsComponent,
    PowerSupplyComponent,
    PowerSupplyCreateComponent,
    PowerSupplyCreatedDialog,
    PowerSupplyDetailsComponent,
    PowerSupplyEditApuComponent,
    PowerSupplyEditApuVisitComponent,
    PowerSupplyEditComponent,
    PowerSupplyEditSupplyComponent,
    PowerSupplyEditSupplysfpComponent,
    PowerSupplyGeneratorAssetDetailsComponent,
    PowerSupplyGeneratorCreateComponent,
    PowerSupplyGeneratorEditComponent,
    PowerSupplyGeneratorSearchDataComponent,
    PowerSupplyGeneratorSearchlistComponent,
    PowerSupplyListComponent,
    PowerSupplyMessageDialog,
    PowerSupplyMoveErrorDialog,
    PowerSupplyNameDialog,
    PowerSupplyNameEditNetConnectDialog,
    PowerSupplyNameNetConnectDialog,
    PowerSupplyNavBarComponent,
    PowerSupplyNotebookComponent,
    PowerSupplypage401Component,
    PowerSupplySelftestdataComponent,
    PowerSupplyTelemetryComponent,
    PowerSupplyTelemetryPsScoredialogComponent,
    PowerSupplyTelemetryThresholddialogComponent,
    PowerSupplyTestComponent,
    PowerSupplyTooltipComponent,
    PowerSupplyUpdatedDialog,
    PsnbCerthistoryComponent,
    QrScannerDialogComponent,
    RefuelRecoveryGeneratorDialogComponent,
    SearchDataDeployGeneratorDialogComponent,
    PowerSupplySelectionDialogComponent,
    SearchDataQrScannerDialogComponent,
    SearchPipe,
    SelftestconfirmDialogComponent,
    UploadDialog,
    ValidationErrorDialog,
    WorkItemDeleteDialogComponent
  ],
  entryComponents: [
    CreateAssetDialogComponent,
    DeployGeneratorDialogComponent,
    EditTestDurationRendererComponent,
    PowerSupplyEditApuComponent,
    PowerSupplyEditApuVisitComponent,
    PowerSupplyEditSupplyComponent,
    PowerSupplyEditSupplysfpComponent,
    PowerSupplyGeneratorSearchDataComponent,
    PowerSupplyGeneratorSearchlistComponent,
    PowerSupplyNameEditNetConnectDialog,
    PowerSupplyNameNetConnectDialog,
    PowersupplyCertWorkitemComponent,
    QrScannerDialogComponent,
    RefuelRecoveryGeneratorDialogComponent,
    SearchDataDeployGeneratorDialogComponent,
    PowerSupplySelectionDialogComponent,
    SearchDataQrScannerDialogComponent,
    UploadDialog,
    WorkItemDeleteDialogComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LoggerModule.forRoot({
      disableConsoleLogging: false,
      level: environment.LOG_LEVEL,
      serverLoggingUrl: `${environment.personnaUrl}api/log-item`,
      serverLogLevel: environment.SERVER_LOG_LEVEL
    }),
    MaterialModule,
    MsalModule,
    ReactiveFormsModule,
    SatPopoverModule,
    ZXingScannerModule
  ],
  providers: [
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalBroadcastService,
    MsalGuard,
    MsalService,
    NetworkHierarchyServiceResourceService,
    NodeServiceResourceService,
    SharedService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: BASE_PATH,
      useValue: window.location.pathname.split('/')[0]
    },
    {
      provide: PSNB_BASE_PATH,
      useValue: environment.psnbBaseUri
    },
    {
      provide: NWT_BASE_PATH,
      useValue: `${environment.psnbBaseUri}/corejson`
    }
  ]
})
export class AppModule {}
